import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

const ControlErrors = ({ errors }) => {

    if (!errors || !errors.length > 0) {
        return null;
    }

    return <Box>
        {errors.map(error => (
            <Typography key={error} variant="subtitle2" color="error">{error}</Typography>
        ))}
    </Box>
};

ControlErrors.propTypes = {
    errors: PropTypes.array
}

export default ControlErrors;